import { useMemo } from "react";
import { TrackingScope } from "@b2bportal/core-tracking";
import type { HotelReservationEventType } from "@b2bportal/core-trips";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { HotelReservationPage } from "@tenant/hotels";
import { useHotelReservationPage, useHotelReservationPageRoute } from "./hooks";

export const HotelReservationPageRoute = ({
  className,
  children,
}: PlatformComponentProps) => {
  const params = useHotelReservationPageRoute();

  const data = useHotelReservationPage({ ...params });
  const trackingAttributes = useMemo(
    () => ({ hotelReservation: data.context.hotelReservation?.reservation }),
    [data.context.hotelReservation]
  );

  return (
    <TrackingScope<HotelReservationEventType>
      trackingAttributes={trackingAttributes}
    >
      <HotelReservationPage {...data} className={className}>
        {children}
      </HotelReservationPage>
    </TrackingScope>
  );
};
